import PropTypes from 'prop-types';
import React from 'react';

const Header = ({ children }) => <header>{children}</header>;

Header.defaultProps = { children: null };
Header.propTypes = { children: PropTypes.node };

export default Header;
